// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import bowser from 'bowser';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import FormGroup from '@material-ui/core/FormGroup';
import CircularProgress from '@material-ui/core/CircularProgress';

import Snackbar from '@material-ui/core/Snackbar';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DialogTitle from '@material-ui/core/DialogTitle';
import makeComponentTrashable from 'trashable-react';
import { TextField } from '@material-ui/core';

import { ToasterComponent } from '../../components/ToasterComponent';

import { authInstance } from '../../firebase';
import {
  fetchWithToken,
  getScribeBackendEndpoint,
  getAvaBackendEndpoint,
} from '../../utils/http';

import Transition from '../../components/Transition';

const labels = {
  gt: 'Given That',
  wh: 'What Happened',
  wshh: 'What Should Have Happened',
};

type Props = {
  close: Function,
  conversationId: string,
  firebaseLoginSuccess: Function,
  firebaseUser: FirebaseUser,
  old: Boolean,
  open: boolean,
  registerPromise: Function,
  status: Object,
};

type State = {
  description: string,
  isMounted: boolean,
  submitting: boolean,
  tagChecked: Object,
  tags: Array<Object>,
  toasterOpen: boolean,
  toasterText: string,
  toasterType: string,
  gt?: string,
  wh?: string,
  wshh?: string,
};

class ScribeReportModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      description: '',
      submitting: false,
      tags: [],
      tagChecked: {},
      isMounted: false,
      toasterText: '',
      toasterOpen: false,
      toasterType: '',
      gt: '',
      wh: '',
      wshh: '',
    };

    this.handleDescription = this.handleDescription.bind(this);
  }

  componentDidMount = () => {
    this.state.isMounted = true;

    const { firebaseLoginSuccess } = this.props;

    this.getTags();
    authInstance.onAuthStateChanged(user => {
      if (user) {
        const { displayName, email, emailVerified, photoURL, uid } = user;
        user.getIdToken().then(idToken => {
          firebaseLoginSuccess({
            displayName,
            email,
            emailVerified,
            photoURL,
            idToken,
            uid,
          });
        });
      }
    });
  };

  componentWillUnmount = () => {
    this.state.isMounted = false;
  };

  getTags = () => {
    const { registerPromise } = this.props;
    registerPromise(
      fetchWithToken(`${getScribeBackendEndpoint()}/api/v1/reports`, {})
    )
      .then(res => res.json())
      .then(json => {
        this.setState({ tags: json.tags });
      });
  };

  submit = () => {
    const {
      firebaseUser: { displayName, email, idToken, uid },
      conversationId,
      close,
      status,
      old,
    } = this.props;
    const { description, tagChecked, wh, wshh, gt } = this.state;

    const browser = bowser.getParser(window.navigator.userAgent);
    const userTechData = browser.parse();

    const payload = {
      name: displayName,
      email,
      idToken,
      description,
      conversationId,
      tags: tagChecked,
      roomId: (status || {}).id || '-',
      hostAvaName: ((status || {}).host || {}).avaName,
      data: {
        currentFrontUrl: window.location.href,
        currentBackUrl: localStorage.getItem('scribeBackendUrl'),
        stack: userTechData.parsedResult,
        release: process.env.HASH_COMMIT,
      },
      asanaMisc: {
        reporterEmail: email,
        reporterName: displayName,
        aiConversationId: (status || {}).conversationId,
        commitHash: process.env.HASH_COMMIT,
        release: process.env.TAG_COMMIT,
        currentFrontUrl: window.location.href,
        currentBackUrl: getAvaBackendEndpoint(),
        ...Object.keys(userTechData.parsedResult).reduce((acc, key) => {
          Object.keys(userTechData.parsedResult[key]).forEach(subkey => {
            acc[`${key}.${subkey}`] = userTechData.parsedResult[key][subkey];
          });
          return acc;
        }, {}),
        roomId: (status || {}).id,
      },
      wh,
      wshh,
      gt,
      reduxState: (
        (window: any).store || { getState: () => 'unknown' }
      ).getState(),
    };
    this.setState({ submitting: true });

    fetchWithToken(
      `${
        old ? getScribeBackendEndpoint() : getAvaBackendEndpoint()
      }/api/v1/reports?firebaseAuthUID=${uid}`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
      }
    ).then(res => {
      if (res.status === 200) {
        close();
        this.openToaster('Report was submitted thanks!', 'success');
      } else {
        this.openToaster('Failed to submit report', 'error');
      }

      this.setState({ submitting: false, tagChecked: {} });
    });
  };

  handleChangeCheckbox = (name: String) => (event: Function) => {
    const { tagChecked } = this.state;
    const tagCheckedArray = tagChecked;
    tagCheckedArray[name] = event.target.checked;
    this.setState({ tagChecked: tagCheckedArray });
  };

  handleDescription = (event: SyntheticEvent<HTMLInputElement>) => {
    this.setState({
      description: (event.target: window.HTMLInputElement).value,
    });
  };

  handleChange = (t: 'gt' | 'wh' | 'wshh') => (
    event: SyntheticEvent<HTMLInputElement>
  ) => {
    this.setState({ [t]: (event.target: window.HTMLInputElement).value });
  };

  openToaster = (message, type) => {
    this.setState({
      toasterOpen: true,
      toasterText: message,
      toasterType: type,
    });
  };

  closeToaster = () => {
    this.setState({ toasterOpen: false, toasterText: '' });
  };

  render() {
    const {
      description,
      submitting,
      tagChecked,
      tags,
      toasterOpen,
      toasterText,
      toasterType,
    } = this.state;
    const { open, close, old } = this.props;
    return (
      <>
        {document.body
          ? ReactDOM.createPortal(
            <Snackbar
              anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'center',
                }}
              open={toasterOpen}
              autoHideDuration={4000}
              onClose={this.closeToaster}
              >
              <ToasterComponent
                onClose={this.closeToaster}
                variant={toasterType}
                message={toasterText}
                />
            </Snackbar>,
              document.body
            )
          : null}
        <Dialog
          TransitionComponent={Transition}
          open={open}
          onClose={close}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Ava Scribe Bug Report
          </DialogTitle>
          <DialogContent>
            {old && (
              <>
                <FormGroup row>
                  {tags.map(tag => (
                    <FormControlLabel
                      key={tag.id}
                      control={(
                        <Checkbox
                          checked={!!tagChecked[tag.id]}
                          onChange={this.handleChangeCheckbox(tag.id)}
                          value={tag.id}
                        />
)}
                      label={tag.text}
                    />
                  ))}
                </FormGroup>
                <textarea
                  value={description}
                  style={{ width: '100%', borderRadius: 5 }}
                  rows="5"
                  disabled={submitting}
                  onChange={this.handleDescription}
                />
              </>
            )}
            {!old && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  padding: '10px 0px',
                  minWidth: 500,
                }}
              >
                {['gt', 'wh', 'wshh'].map(t => (
                  <TextField
                    id="outlined-multiline-static"
                    label={labels[t]}
                    multiline
                    key={t}
                    rows="4"
                    defaultValue=""
                    variant="outlined"
                    style={{ margin: 5 }}
                    onChange={this.handleChange(t)}
                  />
                ))}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button variant="text" onClick={close}>
              Cancel
            </Button>
            <Button
              disabled={submitting}
              variant="contained"
              onClick={this.submit}
              color="primary"
            >
              Report
              {submitting && (
                <CircularProgress
                  size="18px"
                  style={{ position: 'absolute' }}
                />
              )}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default makeComponentTrashable(ScribeReportModal);
